import { atom } from "jotai";

export const getPotreeCameraAtom = atom<any | null>(null);